 <style type="text/css">
.calc {
  max-width: 465px;
  display: block;
  float: left;
}
.labelinput {
  width: 100%;
  display: block;
  float: left;
}

.calc label {
  width: 370px;
  display: block;
  float: left;
  margin-bottom: 10px;
}

.calc input.small {
  width: 40px;
  float: left;
  text-align: right;
}

.calc input {
  border: 1px solid silver;
}

.in {
  background-color: #ccffcc;
}

.out {
  background-color: #ffffcc;
  font-weight: bold;
}

.calc span.tag {
  float: left;
}

.calc span.inline {
  background-color: #ffffcc;
  padding-left: 8px;
  padding-right: 8px;
}

img.illustration {
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>

<template>
  <div class="calc">
    <div class="labelinput">
      <label for="h"
        >1. Ange nivåskillnaden i <strong>mm</strong> mellan passet och
        underlaget, med passet i våg</label
      >
      <span class="tag">H=</span
      ><input type="number" v-model.number="h" class="in small" value="7,5" />mm
    </div>
    <div class="labelinput">
      <label for="l">2. Ange passets längd i <strong>centimeter</strong></label
      ><span class="tag">L=</span>
      <input type="number" v-model.number="l" class="in small" value="60" />cm
    </div>
    <div class="labelinput">
      <label for="f1">
        3. Fallet blir då <span class="inline" id="f">{{ f }}</span> mm/m.
        Fallförhållande <span class="inline" id="ff">1 : {{ ff }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import GBRGVKServices from "../../services/GBRGVKServices";

var services = new GBRGVKServices();
services.log("init");

export default {
  data: function () {
    return {
      h: 7.5,
      l: 60,
    };
  },
  computed: {
    f: function () {
      return Math.round(((10 * this.h) / this.l) * 100) / 10;
    },
    ff: function () {
      return Math.round(1000 / this.f);
    },
  },
};
</script>